import { useState } from "react"
import { cn } from "@/lib/utils"

interface FastImageFallbackProps {
  src: string
  alt: string
  fallbackSrc?: string
  className?: string
  onError?: () => void
  loading?: "lazy" | "eager"
  decoding?: "async" | "sync" | "auto"
  sizes?: string
  priority?: boolean
}

export function FastImageFallback({ 
  src, 
  alt, 
  fallbackSrc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
  className,
  onError,
  loading = "lazy",
  decoding = "async",
  sizes,
  priority = false
}: FastImageFallbackProps) {
  const [currentSrc, setCurrentSrc] = useState(src)
  const [hasError, setHasError] = useState(false)

  const handleError = () => {
    if (!hasError && currentSrc !== fallbackSrc) {
      setHasError(true)
      setCurrentSrc(fallbackSrc)
      onError?.()
    }
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={cn("object-cover", className)}
      onError={handleError}
      loading={priority ? "eager" : loading}
      decoding={decoding}
      sizes={sizes}
      style={{ contentVisibility: 'auto', containIntrinsicSize: '300px 200px' }}
    />
  )
}